module.exports = __webpack_public_path__ + "img/Group_27997@2x.15647d67.png";